import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { StoxlyClient } from '@stoxly/api-client';
import type { Body } from '../op-types';

export function createProjectionQueries(client: StoxlyClient) {
  return createQueryKeys('projections', {
    // ['projections', 'projectionsBySymbol', symbol]
    //
    // The CALLER's saved projections for the symbol. The route takes no query: it used to offer
    // `userOnly`, and omitting it returned every user's projections (#4475), so the owner is the
    // token and there is nothing here to widen.
    projectionsBySymbol: (symbol: string) => ({
      queryKey: [symbol],
      queryFn: ({ signal }) =>
        client.projectionsGetProjectionsBySymbol({ params: { symbol }, signal }),
    }),
  });
}

export function createProjectionMutations(client: StoxlyClient) {
  return {
    createProjection: {
      mutationFn: (body: Body<'projectionsCreateProjection'>) =>
        client.projectionsCreateProjection(body),
    },
    updateProjection: {
      mutationFn: ({ id, body }: { id: string; body: Body<'projectionsUpdateProjection'> }) =>
        client.projectionsUpdateProjection(body, { params: { id } }),
    },
    deleteProjection: {
      mutationFn: (id: string) => client.projectionsDeleteProjection(undefined, { params: { id } }),
    },
  };
}
